export default "__VITE_ASSET__BpfEAI8R__"